<template>
    <div>
		<!-- Footer -->
		<div class="px-0 px-xl-5 py-5" style="background-color:#1c1c1c;color:white">
			<b-container class="container-project">
				<b-row>
					<b-col cols="12" xl="3" class="footer-project-logo my-auto">
						<a href=""><b-img class="invest-logo-footer" :src="require('@/assets/images/somos.png')" alt=""></b-img></a>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer',
		data(){
			return{
				
			}
		},
		components:{
		},
		props: {
		},
		mounted(){
		},
		methods:{
			goTo(url, params){
				this.$router.push({ name: url, params: params }).catch();
			},
		}
	}
</script>

<style lang="scss">
a:hover{
	color:inherit!important;
	text-decoration: none!important;
}
.right-footer{
	margin-right:100px;
}
a{
	color:rgb(151, 151, 151);
}

@media (max-width: 992px){
	.left-footer{
		margin-left:0px
	}
	.right-footer{
		margin-right:0px;
	}
}

.instagram-footer:hover{
	fill:red!important;
}

.footer-btn{
	transition:0.2s
}

.footer-btn:hover{
	background-color: #c50f2A!important;
}
.footer-btn:hover p{
	color:white!important;
}

a{
    color:rgb(151, 151, 151)!important
}
</style>
